import React from 'react';
import FooterWrapper from './index.styles';

const Footer = () => (
  <FooterWrapper>
      <span className='madeby'>
         made by <span>💛이나💛 </span>
      </span>
  </FooterWrapper>
);
export default Footer;
